// avatars.js
import { createAvatar } from '@dicebear/avatars';
import * as style from '@dicebear/bottts';

export const getLocalAvatar = (seed = 1) => {
   const svg = createAvatar(style, {
      seed: seed.toString()
   });
   return svg
};
